import React from 'react';
import { Route } from '@reverbdotcom/commons/src/route_settings';

import { HANDPICKED_ROUTE_PATH } from '../components/shared/constants';

const HandpickedRoute = (
  <Route
    key={HANDPICKED_ROUTE_PATH}
    path={HANDPICKED_ROUTE_PATH}
    props={{
      clientSide: true,
    }}
    getComponent={(_, cb) => {
      import(
        /* webpackChunkName: 'marketplace' */
        '../components/marketplace/handpicked_page'
      ).then(m => cb(null, m.default));
    }}
  />
);

export default HandpickedRoute;
